import React, { useRef, useEffect, useCallback } from "react";
import styles from "../services/Services.module.css";
import heroVideo from "../../videos/hero-video.mp4";

const WHATSAPP_NUMBER = "972505864422";
const waUrl = (t) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(`היי לילך, הגעתי מהאתר שלך ואשמח לשמוע עוד על ${t}`)}`;

const Hero = () => {
  const mobileVideoRef = useRef(null);
  const desktopVideoRef = useRef(null);

  const forcePlay = useCallback((video) => {
    if (!video) return;
    video.muted = true;
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {
        // Retry on user interaction if autoplay blocked
        const tryPlay = () => {
          video.play().catch(() => {});
          document.removeEventListener("touchstart", tryPlay);
          document.removeEventListener("click", tryPlay);
        };
        document.addEventListener("touchstart", tryPlay, { once: true });
        document.addEventListener("click", tryPlay, { once: true });
      });
    }
  }, []);

  useEffect(() => {
    forcePlay(mobileVideoRef.current);
    forcePlay(desktopVideoRef.current);
  }, [forcePlay]);

  return (
    <div className={styles.servicesSection}>
      {/* Hero - Mobile (always) */}
      <div className={styles.heroMobile}>
        <video ref={mobileVideoRef} className={styles.heroVideoEl} autoPlay loop muted playsInline preload="metadata">
          <source src={heroVideo} type="video/mp4" />
        </video>
        <div className={styles.heroVideoOverlay} />
        <div className={styles.heroVideoContent}>
          <h1 className={styles.heroVideoTitle}>לעצב את הבית שלכם<br /><span className={styles.heroAccent}>בלי לשלם על טעויות בדרך</span></h1>
          <p className={styles.heroVideoTagline}>סטודיו בוטיק לתכנון ועיצוב פנים עם ליווי ופיקוח צמוד שחוסך לכם טעויות יקרות, מונע בלת"מים ומוביל אתכם לבית שחלמתם עליו</p>
          <div className={styles.heroBtns}>
            <a href={waUrl("עיצוב פנים")} target="_blank" rel="noopener noreferrer" className={styles.heroBtnContact}>יצירת קשר</a>
          </div>
        </div>
        <div className={styles.heroScrollHint}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M7 13l5 5 5-5M7 6l5 5 5-5"/></svg>
        </div>
      </div>

      {/* V1 - Curved split, video left, white text side */}
      <div className={styles.heroDesktop}>
        <div className={styles.diagHero}>
          <div className={styles.diagVideoSide}>
            <video ref={desktopVideoRef} className={styles.diagVideo} autoPlay loop muted playsInline preload="metadata">
              <source src={heroVideo} type="video/mp4" />
            </video>
          </div>
          <div className={styles.diagTextSide}>
            <div className={styles.diagTextInner}>
              <h1 className={styles.diagTitle}>לעצב את הבית שלכם</h1>
              <h2 className={styles.diagAccentTitle}>בלי לשלם על טעויות בדרך</h2>
              <p className={styles.diagTagline}>סטודיו בוטיק לתכנון ועיצוב פנים עם ליווי ופיקוח צמוד שחוסך לכם טעויות יקרות, מונע בלת"מים ומוביל אתכם לבית שחלמתם עליו</p>
              <a href={waUrl("עיצוב פנים")} target="_blank" rel="noopener noreferrer" className={styles.diagCta}>יצירת קשר</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
